import React from "react";
import MejorateQuiz from "./MejorateQuiz";

const preguntasAlcohol = [
  // Pregunta 1
  {
    question:
      "Adivina cuántas muertes al año en España se atribuyen al consumo de alcohol",
    options: ["10.000", "20.000", "15.489", "25.000"],
    correctAnswerIndex: 2,
  },
  // Pregunta 2
  {
    question:
      "De cada 4 personas que mueren en España por causas relacionadas con el alcohol, ¿cuántas son hombres?",
    options: [
      "1 hombre de cada 4 personas",
      "2 hombres de cada 4 personas",
      "3 hombres de cada 4 personas",
      "Los 4 son hombres",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 3
  {
    question:
      "¿Cuál es uno de los riesgos más significativos del consumo de alcohol?",
    options: [
      "La disminución de la hiperactividad",
      "El desarrollo de dependencia y/o adicción",
      "La mejora de la función respiratoria",
      "El desarrollo de una mayor capacidad de aprendizaje",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 4
  {
    question:
      "¿Cuál es una consecuencia de la naturaleza adictiva del alcohol en los consumidores habituales?",
    options: [
      "La aversión progresiva hacia el alcohol",
      "La necesidad de consumir más para obtener los mismos efectos",
      "La reducción de la tolerancia con el tiempo",
      "La mejora del control sobre el consumo",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 5
  {
    question:
      "¿Cuáles de los siguientes trastornos están fuertemente asociados con el abuso de alcohol?",
    options: [
      "Trastorno obsesivo-compulsivo, autismo y esquizofrenia",
      "Estrés postraumático y fobias",
      "Depresión, ansiedad y trastornos del sueño",
      "Psicosis y síndrome de Tourette",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 6
  {
    question:
      "¿Qué factores contribuyen al daño cerebral causado por el alcohol?",
    options: [
      "El nivel de alcohol en sangre",
      "La neurotoxicidad del etanol y la neuroinflamación",
      "El exceso de proteínas en la dieta",
      "Únicamente la predisposición genética",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 7
  {
    question:
      "¿Qué funciones cerebrales pueden verse principalmente afectadas por el consumo de alcohol?",
    options: [
      "Memoria, coordinación y control de impulsos",
      "Percepción del tiempo y la temperatura",
      "Sentido del olfato",
      "Capacidad para respirar",
    ],
    correctAnswerIndex: 0,
  },
  // Pregunta 8
  {
    question:
      "¿Por qué se relaciona el consumo de alcohol con un aumento del riesgo de desarrollar enfermedades neurodegenerativas?",
    options: [
      "Porque estimula el crecimiento de tejido cerebral",
      "Porque ocasiona la muerte de células neuronales",
      "Porque aumenta la producción de antioxidantes en el cerebro",
      "Porque promueve la regeneración de neuronas",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 9
  {
    question:
      "¿Qué enfermedades neurodegenerativas están asociadas con el consumo excesivo de alcohol?",
    options: [
      "Epilepsia y esclerosis múltiple",
      "Síndrome de Tourette y miastenia gravis",
      "Alzheimer, demencia y Parkinson",
      "Fibromialgia y encefalitis",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 10
  {
    question:
      "¿Qué efectos produce el envejecimiento cerebral ocasionado por el alcohol?",
    options: [
      "Mejora el funcionamiento del lóbulo occipital y el bulbo raquídeo",
      "Favorece el desarrollo del cerebelo y la amígdala",
      "Daña la corteza frontal, el hipocampo y el tálamo",
      "Potencia la actividad del tronco cerebral",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 11
  {
    question:
      "¿Cómo crees que se manifiesta el envejecimiento cerebral causado por alcohol?",
    options: [
      "Mejora la creatividad y percepción",
      "Acelera el aprendizaje",
      "Disminuye la memoria y las capacidades cognitivas",
      "Reduce los niveles de estrés",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 12
  {
    question:
      "¿Sabías que tu hígado es como un filtro que limpia tu sangre? ¿Qué enfermedades graves puede causar el exceso de alcohol en este órgano vital?",
    options: [
      "Hepatitis alcohólica y cirrosis",
      "Hepatitis viral y esteatosis no alcohólica",
      "Insuficiencia renal y pancreatitis",
      "Cálculos biliares y síndrome de Gilbert",
    ],
    correctAnswerIndex: 0,
  },
  // Pregunta 13
  {
    question:
      "¿Qué efectos puede causar el alcoholismo en el sistema cardiovascular?",
    options: [
      "Hipertensión arterial, cardiomiopatía y arritmias cardíacas",
      "Aumento de la elasticidad arterial y reducción de la frecuencia cardíaca",
      "Disminución del colesterol malo y mejora del ritmo cardíaco",
      "Reducción del riesgo de infartos y derrames cerebrales",
    ],
    correctAnswerIndex: 0,
  },
  // Pregunta 14
  {
    question:
      "¿Qué consecuencia grave en el sistema cardiovascular se relaciona estrechamente con el alcoholismo?",
    options: [
      "Riesgo elevado de accidentes cerebrovasculares e infartos",
      "Hipotensión extrema y síncope",
      "Aumento de la capacidad del corazón para bombear sangre eficientemente",
      "Desmineralización ósea y aumento de la viscosidad sanguínea",
    ],
    correctAnswerIndex: 0,
  },
  // Pregunta 15
  {
    question:
      "¿Qué efectos puede causar el consumo excesivo de alcohol en el aparato digestivo?",
    options: [
      "Gastritis, úlceras y pancreatitis",
      "Aumento de la acidez estomacal y estreñimiento",
      "Reducción de la producción de jugos gástricos y digestión lenta",
      "Mejora de la flora intestinal y absorción de nutrientes",
    ],
    correctAnswerIndex: 0,
  },
  // Pregunta 16
  {
    question:
      "¿En qué grupo de carcinógenos están clasificadas las bebidas alcohólicas?",
    options: [
      "Grupo 2A (probablemente carcinógeno para el ser humano)",
      "Grupo 3 (no clasificado como carcinógeno para el ser humano)",
      "Grupo 1 (carcinógeno para el ser humano)",
      "Grupo 2B (posiblemente carcinógeno para el ser humano)",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 17
  {
    question:
      "¿Cuántos tipos diferentes de cáncer están directamente relacionados con el consumo de alcohol?",
    options: [
      "1 tipo de cáncer",
      "3 tipos de cáncer",
      "5 tipos de cáncer",
      "8 tipos de cáncer",
    ],
    correctAnswerIndex: 3,
  },
  // Pregunta 18
  {
    question:
      "¿Qué efecto tiene el consumo excesivo de alcohol sobre el sistema inmunológico?",
    options: [
      "Lo debilita, haciendo al cuerpo más susceptible a enfermedades",
      "Lo fortalece, mejorando la respuesta inmune",
      "No tiene ningún impacto sobre el sistema inmunológico",
      "Aumenta la producción de anticuerpos y células T",
    ],
    correctAnswerIndex: 0,
  },
  // Pregunta 19
  {
    question:
      "¿Qué efectos puede tener el consumo de alcohol durante el embarazo?",
    options: [
      "Aumenta el desarrollo cerebral del feto",
      "Puede causar daños graves al feto, incluyendo el síndrome de alcoholismo fetal",
      "Mejora la salud del feto y previene malformaciones",
      "No tiene efectos significativos en el desarrollo fetal",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 20
  {
    question:
      "¿Qué efecto tiene el acetaldehído, un metabolito del alcohol, sobre el ADN?",
    options: [
      "Puede dañar el ADN y bloquear su síntesis y reparación",
      "Mejora la estructura del ADN y acelera su reparación",
      "No tiene impacto sobre el ADN",
      "Estimula la regeneración celular del ADN",
    ],
    correctAnswerIndex: 0,
  },
  // Pregunta 21
  {
    question:
      "¿Qué efectos adicionales provoca el alcohol que contribuyen al daño del ADN?",
    options: [
      "Aumento de la producción de células madre",
      "Provoca inflamación y estrés oxidativo, dañando más el ADN",
      "Reduce la inflamación y mejora la reparación del ADN",
      "Protege el ADN de agentes externos y mutaciones",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 22
  {
    question:
      "¿Qué impacto puede tener el alcoholismo en la vida personal del consumidor?",
    options: [
      "Mejora la comunicación y fortalece los vínculos con su entorno",
      "Deteriora las relaciones personales y familiares",
      "Aumenta la empatía y el entendimiento",
      "Fomenta la cercanía emocional",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 23
  {
    question: "¿Cómo afecta el alcoholismo al ámbito laboral?",
    options: [
      "Mejora el rendimiento y la productividad",
      "Causa ausentismo, disminución del rendimiento y afecta la estabilidad económica",
      "Genera nuevas oportunidades laborales",
      "Fortalece las relaciones profesionales",
    ],
    correctAnswerIndex: 1,
  },
  // Pregunta 24
  {
    question:
      "¿Cómo afecta el consumo excesivo o crónico de alcohol a la esperanza de vida?",
    options: [
      "La aumenta debido a sus efectos relajantes",
      "La mantiene estable a largo plazo",
      "La acorta debido al aumento del riesgo de accidentes, violencia e intoxicación alcohólica",
      "La incrementa al mejorar la salud cardiovascular",
    ],
    correctAnswerIndex: 2,
  },
  // Pregunta 25
  {
    question: "¿Qué hace que el alcohol sea más peligroso para la salud?",
    options: [
      "Hacer ejercicio con frecuencia y llevar una buena dieta",
      "La ocupación y la educación de la persona",
      "La cantidad y duración del consumo",
      "Las horas de sueño y el tiempo al sol",
    ],
    correctAnswerIndex: 2,
  },
];

export default function MejorateAlcohol() {
  return <MejorateQuiz quizType="Alcohol" questions={preguntasAlcohol} />;
}
